module.exports = __webpack_public_path__ + "img/alerts-7.85a04aaa.gif";